<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px'
    }"
  >
    <h1>分销佣金设置</h1>
    <a-form>
      <!-- <a-form v-bind="formItemLayout" :form="form" @submit="handleSubmit"> -->
      <a-form-item label="">
        <a-input-group compact>
          <a-input style="width: 15%" default-value="一级比例" />
          <a-input
            style="width: 30%"
            v-model="One"
            type="number"
            @blur="numJudge($event, 'One')"
          />
        </a-input-group>
      </a-form-item>
      <a-form-item label="">
        <a-input-group compact>
          <a-input style="width: 15%" default-value="二级比例" />
          <a-input
            style="width: 30%"
            v-model="Two"
            type="number"
            @blur="numJudge($event, 'Two')"
          />
        </a-input-group>
      </a-form-item>
      <a-form-item label="">
        <a-input-group compact>
          <a-input style="width: 15%" default-value="三级比列" />
          <a-input
            v-model="Three"
            type="number"
            style="width: 30%"
            @blur="numJudge($event, 'Three')"
          />
        </a-input-group>
      </a-form-item>
      <a-form-item label="" class="text">
        tips：三级分销佣金是基于【订单支付金额】计算分润给三级分销用户，比如订单支付100元，设置一级分销比例3%，二级分销比例2
        %，三级分销比例1%，那么一级分销用户获得3币奖励，二级分销用户获得2币奖励，三级分销用户获得1币奖励，注：分销比例可设置为0，但佣金比例总和不能超过100%</a-form-item
      >
      <a-form-item
        :wrapper-col="{
          xs: { span: 24, offset: 0 },
          sm: { span: 16, offset: 8 }
        }"
      >
        <a-button
          type="primary"
          html-type="submit"
          size="large"
          style="width: 150px"
          @click="edit"
        >
          更新
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
// import chooseAnItem from "./chooseAnItem.vue";
import {
  getDistributionBinding,
  updateDistributionBinding
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";
import { distribution, edit_distribution } from "@/api/storeApi.js";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      data: [],
      show: false,
      One: null,
      Two: null,
      Three: null,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      }
    };
  },
  created() {
    // this.getDistributionBindingData();
    this.getdistribution();
  },
  methods: {
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    getDistributionBindingData() {
      getDistributionBinding().then(res => {
        this.One = res.data.firstDistribution;
        this.Two = res.data.secondDistribution;
        this.Three = res.data.thirdDistribution;
      });
    },
    getdistribution() {
      distribution().then(res => {
        console.log("res", res);
        this.One = res.data.firstDistribution;
        this.Two = res.data.secondDistribution;
        this.Three = res.data.thirdDistribution;
      });
    },
    edit() {
      let total = this.One + this.Two + this.Three;
      if (total > 100) {
        message.warning("佣金比例总和不能超过100%");
        return;
      }
      edit_distribution(this.One, this.Two, this.Three).then(res => {
        if (res.code === "0000") {
          this.getdistribution();
          message.success(res.info);
        } else {
          message.warning("分销佣金不可为空");
        }
      });
    },
    numJudge(e, obj) {
      let num = Number(e.target.value);
      if (num <= 0) {
        num = 0;
      }
      if (num > 100) {
        num = 100;
      }
      this[obj] = num;
    },
    showtable(show) {
      this.show = show;
    }
  }
};
</script>

<style scoped>
.text {
  width: 700px;
  color: red;
}
h1 {
  font-size: 28px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/ticketPackage/ticketPackageAdd.vue